'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M5.637 4.223a1 1 0 0 1 0 1.414 9 9 0 0 0 0 12.726 1 1 0 1 1-1.414 1.414 11 11 0 0 1 0-15.554 1 1 0 0 1 1.414 0m12.726 0a1 1 0 0 1 1.414 0 11 11 0 0 1 0 15.554 1 1 0 0 1-1.414-1.414 9 9 0 0 0 0-12.726 1 1 0 0 1 0-1.414m-9.896 2.82a1 1 0 0 1 0 1.415 5 5 0 0 0 0 7.075 1 1 0 1 1-1.414 1.415 7 7 0 0 1 0-9.905 1 1 0 0 1 1.414 0m7.065.01a1 1 0 0 1 1.415 0 7 7 0 0 1 0 9.905 1 1 0 0 1-1.414-1.415 5 5 0 0 0 0-7.075 1 1 0 0 1 0-1.414" clipRule="evenodd" /></svg>;
const IconReach = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconReach;